import { EditorState } from 'draft-js';

/**
 * @param {EditorState} editorState
 */
export function getSelectedBlock(editorState, noCollapsedRequired = false) {
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();

	if (selection.isCollapsed() || noCollapsedRequired) {
		return content.getBlockForKey(selection.getAnchorKey());
	}

	return null;
}


// WEBPACK FOOTER //
// ./lib/helpers/getSelectedBlock.js